export * as Instrumentation from './config';
export { useObservability } from './openTelemetry';
export * as Attributes from './attributes';
export { BLOCK_OBSERVABILITY_ATTRIBUTE, OBSERVABILITY_UNMASK_ATTRIBUTE } from './constants';

export {
    useJourneyTracker,
    JourneyTrackerProvider,
    createJourneyTracker,
    getCurrentJourneyTracker,
    /** @deprecated only use in legacy static contextType cases */
    JourneyTrackerContext,
} from './journeyTracker/journeyTracker';
export type { JourneyTracker } from './journeyTracker/journeyTracker';
export { createJourneyTrackingMiddleware } from './journeyTracker/journeyTrackingMiddleware';
export { useReactQueryJourneyTracking } from './journeyTracker/journeyTrackingReactQuery';

import { createTrace, closeTrace, addAnalytics, addLog, addMetrics } from './openTelemetry';
import { setUserContext, updateLabels } from './coralogix';

export const Observability = {
    createTrace,
    closeTrace,
    addAnalytics,
    addLog,
    addMetrics,
    setUserContext,
    updateLabels,
};
